import { render } from "./MailingBlockColumnsEditor.vue?vue&type=template&id=6bb6a472"
import script from "./MailingBlockColumnsEditor.vue?vue&type=script&lang=js"
export * from "./MailingBlockColumnsEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__